import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import { PermissionsModel } from "src/app/modules/common/entity/permissions.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class DeviceDefinitionSummaryModel implements SummaryModel {
  id: number;
  permissions: PermissionsModel;
  model: string;
  type: LovValueSummary;
}

